import { observer } from 'mobx-react-lite';
import { ElementConfigType } from '../store/PageEditorStore';
import ComponentFactory from '../component-factory/ComponentFactory';
import React from 'react';
import { ComponentBasicRenderProd } from '@/pages2/DetailedDescription/editor/ComponentBasicRenderProd';

const ComponentItemRenderProd = observer((props: ElementConfigType) => {
  const { componentId } = props;
  const Component = ComponentFactory.getComponentById(componentId);

  // hook handler

  return (
    <>
      {Component ? (
        <Component
          {...props}
          ComponentBasicRender={ComponentBasicRenderProd}
          ComponentItemRender={ComponentItemRenderProd}
        />
      ) : (
        <p>渲染错误</p>
      )}
    </>
  );
});

export default ComponentItemRenderProd;
